import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {Money,AccountBalance,Search,CreditCard,Dialpad,PhoneAndroid,AlternateEmail,AccountBalanceWallet,Person,ArrowForwardIos,LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,People,CheckCircleOutline,NotInterested,Cancel,RemoveCircleOutline,Visibility,VisibilityOff} from '@material-ui/icons';


import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Chip,
  isWidthUp,
  OutlinedInput,
  InputAdornment,
  Grid,
  Badge,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  ButtonGroup,
  ListItemIcon
} from "@material-ui/core";
import Skeleton from '@material-ui/lab/Skeleton';

import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";
import API from './api';

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';

import Format from "date-fns/format";

// import * as userInfo from "./login_info.js";

import UserInfo from "./login_info";

import axios from 'axios';


import {TransportService,AdminService,ReportingService,FinanceService,generateReference,formatMoney} from "../../utils/web_config_2";
import { pink } from '@material-ui/core/colors';
import { set } from 'date-fns';

import {useHistory } from "react-router-dom";


import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image
} from "@react-pdf/renderer";

import MaskedInput from "react-text-mask";

import User from '../../assets/svg/user.svg'

// mask NID 

const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/[0-9]/,' ',/[0-9]/ ,/\d/, /\d/, /\d/, ' ', /[0-9]/,' ',/[0-9]/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,' ',/[0-9]/,' ',/[0-9]/,/\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};


const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
},
chip:{
  margin: theme.spacing(0.5),
  textTransform:"capitalize"
},
paper_one:{
    height:600,
},
box:{
    padding:10
}

}));




function AgentOperatorDetails() {
  const classes = useStyles1();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [operatorData, setOperatorData] = useState({});

  const history = useHistory();

  const [userMessage,setUserMessage]=useState("");

  const [agentManager,setAgentManager]=useState({});


const columns = [
  {
    name: "agent_manager_team_id",
    label: "id",
    options: {
      display:false,
     filter: true,
     sort: true,
    }
   },
  {
   name: "names",
   label:"Names",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "user_email",
   label:"Email",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "user_gender",
   label: "Gender",
   options: {
    filter: true,
    sort: false,
   }
  }, 
  
   {
    name: "user_status",
    label: "Agent Status",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
      //  console.log(value);
       if(value=="ENABLED"){
        return (
          <Chip
          variant="outlined"
          size="small"
          color="primary"
          icon={<CheckCircleOutline/>}
          label={value}
        />
            
        );
       }else if(value=="DISABLED"){
        return (
          <Chip
          variant="outlined"
          size="small"
          color="secondary"
          icon={<NotInterested/>}
          label={value}
        />
            
        );
       }else if(value=="SUSPENDED"){
         return (
          <Chip
          variant="outlined"
          size="small"
          color="secondary"
          icon={<Cancel/>}
          label={value}
        />
          );
       
       }
     
    }
    }
   },
   {
    name: "status",
    label: "Relation Status",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
       console.log(value);
       if(value=="ACTIVE"){
        return (
          <Chip
          variant="outlined"
          size="small"
          color="primary"
          icon={<CheckCircleOutline/>}
          label={value}
        />
            
        );
       }else if(value=="DISABLED"){
        return (
          <Chip
          variant="outlined"
          size="small"
          color="secondary"
          icon={<NotInterested/>}
          label={value}
        />
            
        );
       }else if(value=="SUSPENDED"){
         return (
          <Chip
          variant="outlined"
          size="small"
          color="secondary"
          icon={<Cancel/>}
          label={value}
        />
          );
       
       }
     
    }
    }
   }
 ];


 

 const options = {
  textLabels: {
    body: {
      noMatch: userMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,

  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
 


<Chip
 className={classes.chip}
          variant="outlined"
          size="medium"
          color="secondary"
          icon={<RemoveCircleOutline/>}
          label={"Remove Agent"}
          onClick={()=>{


            enqueueSnackbar("Agent renconciliation is not yet done!", { 
                variant: 'error',
            });

            // console.log("data");
            // console.log(displayData[selectedRows.data[0]['index']]['data'][0]);
            // console.log(displayData[selectedRows.data[0]['index']]['data'][0]);
            // setUserId(displayData[selectedRows.data[0]['index']]['data'][0]);
            // setDeactiveDialog(true);
          }}
        />


      </Box>
  ),
 };


 const columnsTransaction = [
    {
      name: "id",
      label: "id",
      options: {
        display:false,
       filter: false,
       sort: true,
      }
     },
    {
     name: "tx_type_name",
     label: "Transaction Type",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
     name: "channel_type",
     label:"Channel",
     options: {
      filter: true,
      sort: false,
     }
    },
    {
     name: "credited_account",
     label: "Account",
     options: {
      filter: true,
      sort: false
     }
    }, {
      name: "amount",
      label:"Amount",
      options: {
       filter: true,
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
        return(<Typography>{formatMoney(value,0)}</Typography>)
      }
      }
     },
     {
      name: "debited_account_balance",
      label:"Debited Account Balance",
      options: {
       filter: true,
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
        return(<Typography>{formatMoney(value,0)}</Typography>)
      }
      }
     },
     {
     name: "credited_account_balance",
     label: "Credited Account Balance",
     options: {
       filter: true,
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
         return (<Typography>{formatMoney(value, 0)}</Typography>)
       }
     }
   },
     {
      name: "total_commission_amount",
      label: "Commission",
      options: {
        display:false,
       filter: true,
       sort: true,
      }
     },
     {
      name: "tx_date",
      label: "Date",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
        name: "tx_time",
        label: "Time",
        options: {
         filter: true,
         sort: true,
        }
       }
       ,
     {
        name: "status",
        label: "Status",
        options: {
         filter: true,
         sort: true,
        }
       }
     
   ];
  
  
   
  
   const optionsTransaction = {
    textLabels: {
      body: {
        noMatch: "No Transactions available"
      },
    },
     filterType: 'checkbox',
     download:true,
     responsive:"standard",
     selectableRows:"single",
     rowsPerPage: 10,
     elevation:0,
  
   };
  

   const [orgInfo,setOrgInfo]=useState({});

   const [operatorAgent,setOperatorAgent]=useState({});

  useEffect(()=>{

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }

    setOperatorData(data);
    axios.defaults.baseURL = new AdminService().BASE_URL;

    if(history.location.state===undefined){
        history.push("/operator/agent");
        return;
    }

  

    setAgentManager(history.location.state);
    getAgentWithoutManager(data.token);
    var d=history.location.state;
    // console.log("ddddddddd",d);


    var operatorAgentProfile=JSON.parse(localStorage.getItem("operatorAgent"));
    setOperatorAgent(operatorAgentProfile);

    console.log("data operator profile",operatorAgentProfile);
    getBalance(data.token,operatorAgentProfile.agent_code);

    
    

    getAgentManagerProfile(data.token,d.agent_code);

    getTransactions(data.token,d.agent_code,Format(new Date(), ["yyyy-MM-dd",]),Format(new Date(), ["yyyy-MM-dd",]));

    load_details(data.token);

  },[]);



  const [agentBalance,setAgentBalance]=useState({});

  const getBalance=(token,agent_code)=>{
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const reportInstance = axios.create(new FinanceService().setHeaders(token));
    reportInstance.get('/api/v1/getAgentBalance/'+agent_code
    ).then(res=>{
      console.log("balance",res.data.data);
      if(res.data.data!=null){
        setAgentBalance(res.data.data);
      }else{
        enqueueSnackbar("Data :: Null", { 
          variant: 'info',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
      
    })
    .catch(err=>{

    });
  }


  // get agent manager profile


  const [agentProfile,setAgentProfile]=useState({});

  const [loadProfile,setLoadProfile]=useState(false);

  const getAgentManagerProfile=(token,agentCode)=>{
    setLoadProfile(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const agentInstance = axios.create(new FinanceService().setHeaders(token));
    agentInstance.get('/api/v1/getAgentProfile/'+agentCode
    ).then(res=>{
      var data=res.data.data;
      console.log("agent profile",data.account);



      setAgentProfile(data.account);

      setLoadProfile(false);
       
    }).catch(err=>{
      setLoadProfile(false);
      // console.log(err);
      if(err.message){
        enqueueSnackbar(err.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
     

    if(err.response){
      if(err.response.status==401){
        history.push("/", { expired: true });
        enqueueSnackbar(err.message, { 
          variant: 'error',
      });
      }
    }
   

    });
  }




 

  const [display,setDisplay]=useState("transaction");

  const [loadAgent,setLoadAgent]=useState(false);
  

  const [assignedAgents,setAssignedAgents]=useState([]);

  const [agents,setAgents]=useState([]);




//   fetch agent without agent manager 

  const getAgentWithoutManager=(token)=>{
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const usersInstance = axios.create(new AdminService().setHeaders(token));
    usersInstance.get('/api/v1/user/agent-without-manager/organization/'+new UserInfo().ORG_ID
    ).then(res=>{

        // console.log("agents",res.data.data);
        
      var d=res.data.data;
      if(d.length==0){
        // no agent available 
      }else{
          d.map((o)=>{
              o.selected=false;
          });
        setAgents(d);
      }
    }).catch(err=>{

      // console.log(err);

      if(err.message){
        enqueueSnackbar(err.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
     

    if(err.response){
      if(err.response.status==401){
        history.push("/", { expired: true });
        enqueueSnackbar(err.message, { 
          variant: 'error',
      });
      }

      //   enqueueSnackbar(err.response.data.message, { 
      //     variant: 'info',
      // });
    }
   

    });
  }

  const [assignDialog,setAssignDialog]=useState(false);

  const [selectedAgents,setSelectedAgents]=useState([]);




  const assignTemp = (value) => () => {
    const currentIndex = selectedAgents.indexOf(value);
    const newselectedAgents = [...selectedAgents];

    if (currentIndex === -1) {
      newselectedAgents.push(value);
    } else {
      newselectedAgents.splice(currentIndex, 1);
    }

    setSelectedAgents(newselectedAgents);
  };


  const [addLoading,setAddLoanding]=useState(false);

  const addAgent=()=>{
    
    setAddLoanding(true);
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const usersInstance = axios.create(new AdminService().setHeaders(operatorData.token));
    usersInstance.post('/api/v1/agent-manager-team',
    {
        "agent_manager_id": agentManager.user_id,
        "user_id": selectedAgents
    }
    ).then(res=>{

        // console.log(res.data.data);

        setAddLoanding(false);

        enqueueSnackbar("Agent assigned successfully!", { 
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });

        getAgentManagerProfile(operatorData.token,agentManager.agent_code);

        setSelectedAgents([]);
        setAssignDialog(false);
       
    }).catch(err=>{

        setSelectedAgents([]);
     setAddLoanding(false);
    //   if(err.message){
    //     enqueueSnackbar(err.message, { 
    //       variant: 'error',
    //       anchorOrigin: {
    //         vertical: 'bottom',
    //         horizontal: 'right',
    //     },
    //   });
    //   }
     

    if(err.response){
      if(err.response.status==401){
        history.push("/", { expired: true });
        enqueueSnackbar(err.message, { 
          variant: 'error',
      });
      }

      enqueueSnackbar(err.response.data.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    }
   

    });



  }






  // get ORG prof

  const [loadDetails,setLoadDetails]=useState(true);

  const [details,setDetails]=useState({});

  const load_details=(token)=>{
    setLoadDetails(true);

    console.log("load details......");

    axios.defaults.baseURL = new AdminService().BASE_URL;
    const detailsInstance = axios.create(new AdminService().setHeaders(token));
    detailsInstance.get("/api/v1/organization/"+new UserInfo().ORG_ID)
    .then((res)=>{

     
      setLoadDetails(false);
      setDetails(res.data.data);


    })
    .catch(err=>{

    });

  }



  // allocate float


  const [floatDialog,setFloatDialog]=useState(false);
  const [allocateLoading,setAllocateLoading]=useState(false);
  const [floatAmount,setFloatAmount]=useState({value:0,error:""});

  const [confirm,setConfirm]=useState(false);

  const allocateFloat=()=>{
    if(floatAmount.value<=0){
      setFloatAmount({value:0,error:"Enter correct amount"});
    }else{
      setAllocateLoading(true);

    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const agentsInstance = axios.create(new FinanceService().setHeaders(operatorData.token));
    agentsInstance.post('/api/v1/agentFloatAllocation',
    {
      "channel_type": "WEB",
      "agent_code": details.agent_code,
      "dest_agent_code": agentManager.agent_code,
      "reference_number": generateReference(2000000000),
      "amount": floatAmount.value
    }
    ).then(res=>{
      setAllocateLoading(false);
      setFloatDialog(false);
      setFloatAmount({value:0,error:""});


      getAgentManagerProfile(operatorData.token,agentManager.agent_code);

      enqueueSnackbar("Float Allocated successfully!", { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });

    }).catch(err=>{
      setAllocateLoading(false);
      if(err.message){
        enqueueSnackbar(err.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
     

    if(err.response){
      if(err.response.status==401){
        history.push("/", { expired: true });
        enqueueSnackbar(err.message, { 
          variant: 'error',
      });
      }

      setUserMessage(err.response.data.message);
      enqueueSnackbar(err.response.data.message, { 
        variant: 'info',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });


    }
   

    });

    }
  }


  /// transactions

  const [filterMode,setFilterMode]=useState("TODAY");

  const [loadTransaction,setLoadTransaction]=useState(false);
  const [transactions,setTransactions]=useState([]);
 
  const getTransactions=(token,agent_code,start_date,end_date)=>{
    setTransactions([]);
    setLoadTransaction(true);

    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const reportInstance = axios.create(new FinanceService().setHeaders(token));
    reportInstance.get('/api/v1/getAgentTransactions/' + agent_code + '?start_date=' + start_date + '&end_date=' + end_date +'&per_page=10000'
    ).then(res=>{
      setLoadTransaction(false);
      console.log("transaction",res.data.data);
      setTransactions(res.data.data);
    })
    .catch(err=>{
      setLoadTransaction(false);
    });
  }

    


  return (
    <div className={classes.root}>
     

 {/* agent manager details */}

 <Box mt={2}>

<Grid container spacing={2}>
    <Grid item lg={4} md={4} sm={12} sx={12}>
        <Paper elevation={0} >
        
            <Box className={classes.box}>
                
                <Box display="flex" alignContent="cdnter" justifyContent="center">
                    <img src={User} height="80"/>
                </Box>
                <Box mt={2} display="flex" alignContent="cdnter" justifyContent="center">
                    <Typography><b>{agentManager?.names}</b></Typography>
                </Box>
                
                <Box mt={2}><Divider/></Box>  

                {loadProfile==true?
              <Box>
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </Box>:
               <List dense={true}>

                 
               <ListItem>
                 <ListItemAvatar>
                  <AccountBalance color="primary"/>
                 </ListItemAvatar>
                 <ListItemText
                   primary={<Typography><b>Account Number</b></Typography>}
                 />
                 <ListItemSecondaryAction>
                   <Typography>{agentProfile.account_number}</Typography>
                 </ListItemSecondaryAction>
               </ListItem>
               

               <ListItem>
                 <ListItemAvatar>
                  <AccountBalanceWallet color="primary" color="secondary"/>
                 </ListItemAvatar>
                 <ListItemText
                   primary={<Typography><b>Opening Balance</b></Typography>}
                 />
                 <ListItemSecondaryAction>
                   <Typography>{formatMoney(agentProfile.opening_balance,0)}</Typography>
                 </ListItemSecondaryAction>
               </ListItem>

               <ListItem>
                 <ListItemAvatar>
                  <AccountBalanceWallet color="primary"/>
                 </ListItemAvatar>
                 <ListItemText
                   primary={<Typography><b>Current Balance</b></Typography>}
                 />
                 <ListItemSecondaryAction>
                   <Typography>{formatMoney(agentProfile.current_balance,0)}</Typography>
                 </ListItemSecondaryAction>
               </ListItem>

               </List>
               
              }
               <Box mt={2}><Divider/></Box> 
                <Box mt={2}>
                <List dense={true}>

                



                <ListItem>
                  <ListItemAvatar>
                   <AlternateEmail color="primary"/>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Typography><b>Email</b></Typography>}
                  />
                  <ListItemSecondaryAction>
                    <Typography>{agentManager.user_email}</Typography>
                  </ListItemSecondaryAction>
                </ListItem>


                <ListItem>
                  <ListItemAvatar>
                   <PhoneAndroid color="primary"/>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Typography><b>Phone</b></Typography>}
                  />
                  <ListItemSecondaryAction>
                    <Typography>{agentManager.user_phone}</Typography>
                  </ListItemSecondaryAction>
                </ListItem> 


                <ListItem>
                  <ListItemAvatar>
                   <Dialpad color="primary"/>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Typography><b>TIN Number</b></Typography>}
                  />
                  <ListItemSecondaryAction>
                    <Typography>{agentManager.tin}</Typography>
                  </ListItemSecondaryAction>
                </ListItem>  


                <ListItem>
                  <ListItemAvatar>
                   <CreditCard color="primary"/>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Typography><b>NID</b></Typography>}
                  />
                  <ListItemSecondaryAction>
                    <Typography>{agentManager.user_nid}</Typography>
                  </ListItemSecondaryAction>
                </ListItem> 


            </List>
                </Box>
           
            </Box>

            {/* <Box m={2}>
                <Button onClick={()=>{setAssignDialog(true);}} className={classes.btn} fullWidth color="primary" startIcon={<Add/>} variant="outlined">Add Agent</Button>
            </Box>
            <Box m={2}>
                <Button onClick={()=>{setFloatDialog(true);}} className={classes.btn} fullWidth color="primary" startIcon={<Money/>} variant="outlined">Allocate Float</Button>
            </Box> */}
            <Box style={{height:20}}></Box>
        </Paper>
    </Grid>
    <Grid item lg={8} md={8} sm={12} sx={12}>

    <Paper elevation={0} className={classes.paper_one}>
        <Box style={{height:20}}></Box>
        <Box  display="flex"  flexDirection="row-reverse">

        <Box m={2}>
<ButtonGroup disableElevation size="medium" color="primary" aria-label="outlined primary button group">
  <Button onClick={()=>{
    setFilterMode("TODAY");
    var d = new Date();
    getTransactions(operatorData.token,agentManager.agent_code,Format(d, ["yyyy-MM-dd",]),Format(d, ["yyyy-MM-dd",]));
    

  }}  variant={filterMode=="TODAY"?"contained":"outlined"}>Today</Button>
  <Button onClick={()=>{
    setFilterMode("WEEK");

    var end_date=new Date();

    var start_date = new Date();
    start_date.setDate(start_date.getDate()-7);
    getTransactions(operatorData.token,agentManager.agent_code,Format(start_date, ["yyyy-MM-dd",]),Format(new Date(), ["yyyy-MM-dd",]));

  }} variant={filterMode=="WEEK"?"contained":"outlined"}>Week</Button>
  <Button onClick={()=>{
    setFilterMode("MONTH");

    var end_date=new Date();

    var start_date = new Date();
    start_date.setDate(start_date.getDate()-31);

    getTransactions(operatorData.token,agentManager.agent_code,Format(start_date, ["yyyy-MM-dd",]),Format(end_date, ["yyyy-MM-dd",]));




  }}  variant={filterMode=="MONTH"?"contained":"outlined"}>Month</Button>
</ButtonGroup>
</Box>

        {/* <ButtonGroup color="primary" aria-label="outlined primary button group">
        <Button disableElevation variant={display=="agent"?"contained":"outlined"} onClick={()=>{setDisplay("agent");}}>Agents</Button>
        <Button disableElevation variant={display=="transaction"?"contained":"outlined"} onClick={()=>{setDisplay("transaction");}}>Transactions</Button>
        </ButtonGroup> */}

        </Box>

{display=="agent"&&
 <Box  m={2}>
{loadAgent&&<LinearProgress />}
 <MUIDataTable
  title={"List of Agent"}
  data={assignedAgents}
  columns={columns}
  options={options}
/>
 </Box>
}

{display=="transaction"&&
<Box m={2}>
{loadTransaction&&<LinearProgress />}
 <MUIDataTable
  title={"List of Transaction"}
  data={transactions}
  columns={columnsTransaction}
  options={optionsTransaction}
/>
 </Box>
}


</Paper>
    </Grid>
</Grid>




 </Box> 



 <Dialog
    maxWidth="xs"
    fullWidth
    open={assignDialog}
    onClose={()=>{
      setAssignDialog(false);
    }}

    aria-labelledby="assign_agent"
    aria-describedby="assign_agent"
      >

        <DialogTitle id="assign_agent">{"Add Agents"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
              <Box>
              <TextField size="small"   
              InputProps={{
                endAdornment: <Search/>,
          }} 
          fullWidth 
          placeholder="Search Agent" 
          variant="outlined" />
              </Box> 
              <Box>

              <List>
      {agents.map((v) => {

        return (
          <ListItem  dense button onClick={assignTemp(v.user_id)}>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={selectedAgents.indexOf(v.user_id) !== -1}
                tabIndex={-1}
                disableRipple
              />
            </ListItemIcon>
            <ListItemText  primary={v.user_first_name+" "+v.user_last_name} />
           
          </ListItem>
        );
      })}
    </List>

             </Box>
          </DialogContentText>
        </DialogContent>
        
        <DialogActions>

        {selectedAgents.length>0&&
        <Button className={classes.btn} variant="contained" disableElevation color="primary" onClick={()=>{
            addAgent();
        }}>
         {addLoading==true?<CircularProgress color="secondary" size={25}/>:<Typography>Add ({selectedAgents.length})</Typography>}
          </Button>
        }
      

      </DialogActions>
       
        
      </Dialog>



{/* allocate float  */}



<Dialog
    maxWidth="xs"
    fullWidth
    open={floatDialog}
    onClose={()=>{
      setFloatDialog(false);
    }}

    aria-labelledby="float_agent"
    aria-describedby="float_agent"
      >

        <DialogTitle id="float_agent">{"Allocate Float"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            <Box>
              <Typography>By cliking allocate button, float will be distributed to <b>{agentManager?.user_fname+" "+agentManager?.user_lname}</b></Typography>
            </Box>
              <Box>
              <TextField size="small"   
              InputProps={{
                startAdornment: <Money/>,
          }} 
          type="number"
          // value={floatAmount.value}
          error={floatAmount.error!==""}
          helperText={floatAmount.error}
          onChange={(v)=>{
            if(v.target.value<=0){
              setFloatAmount({value:0,error:"Enter value"});
            }else{
              setFloatAmount({value:v.target.value,error:""});
            }

          }}
          fullWidth 
          placeholder="Float Amount" 
          variant="outlined" />
              </Box> 
              
          </DialogContentText>
        </DialogContent>
        
        <DialogActions>

        <Button className={classes.btn} variant="contained" disabled={allocateLoading} disableElevation color="primary" onClick={()=>{
            allocateFloat();
        }}>
         {allocateLoading==true?<CircularProgress color="secondary" size={25}/>:<Typography>Allocate</Typography>}
          </Button>
     
      

      </DialogActions>
       
        
      </Dialog>



</div>
  );
}

export default  withLocalize(AgentOperatorDetails);